<app-leveltwo [pageName]="'Change in Ownership - Rescission'">
  <div class="General">
    <h3>{{'ChangeAddressRescission.SearchTitle'|translate}}</h3>

      <p>{{'ChangeAddressRescission.UnderProp13'|translate}}</p>
      <h4>{{'ChangeAddressRescission.MutualRescission'|translate}}</h4>
      <p>{{'ChangeAddressRescission.Partiesto'|translate}}</p>
      <ul>
        <li>{{'ChangeAddressRescission.Partiesto1'|translate}}</li>
        <li [innerHTML]="'ChangeAddressRescission.Partiesto2'|translate"></li>
        <li>{{'ChangeAddressRescission.Partiesto3'|translate}}</li>
      </ul>
      <p [innerHTML]="'ChangeAddressRescission.Note'|translate"></p>
      <h4>{{'ChangeAddressRescission.CourtOrderedRescission'|translate}}</h4>
      <p>{{'ChangeAddressRescission.PartiestoatransferV2'|translate}}</p>
      <h4>{{'ChangeAddressRescission.AssessorRescissionPolicy'|translate}}</h4>
      <p [innerHTML]="'ChangeAddressRescission.Foradditional'|translate"></p>





  </div>

</app-leveltwo>
